import { OpenwebLoginRoutes } from '@framework/auth-open-web';

export const FrontLoginRoutes = [...OpenwebLoginRoutes];
